import { ReactNode } from 'react'
import styles from './AppContainer.module.scss'
import { useLocation } from 'react-router-dom'

interface AppContainerProps {
  children: ReactNode
  className?: string
}


export const AppContainer = ({ children, className }: AppContainerProps) => {
  const pathname = useLocation().pathname;
  return (
    <div className={`${styles.container} ${pathname === '/' ? styles.mainPage : ''} ${className || ''}`}>
      {children}
    </div>
  )
} 